export default __webpack_public_path__ + "Logo_XL 1.png";